import React, { Component } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import FlashcardPageView from "../component/FlashcardPageView";
import FlashcardUsageAnalytics from "../model/FlashcardUsageAnalytics";
import "./FlashcardView.css";
import { LEFT, RIGHT } from "../enum/Directions";
import $ from "jquery";

export class FlashcardView extends Component {
  constructor(props) {
    super(props);
    const { flashActivity, getAnalyticsDataFn } = this.props;
    getAnalyticsDataFn(this.getAnalyticsData.bind(this));
    const usageAnalyticsModel = FlashcardUsageAnalytics({
      activityItemsCount: flashActivity.flashcardPages.length,
      previousUsageAnalytics: flashActivity.usageAnalytics
    });
    this.state = {
      currentPageIndex: this.getInitialPageIndex(usageAnalyticsModel),
      isDocumentBeingViewed: true,
      documentActiveChecker: null,
      usageTimestamp: new Date().valueOf(),
      usageAnalyticsModel
    };
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
  }

  static propTypes = {
    flashActivity: PropTypes.object.isRequired,
    onUpdateAnanlyticsData: PropTypes.func,
    showToastMessage: PropTypes.func,
    onUpdateAppSwipe: PropTypes.func,
    dndInProgress: false
  };

  static defaultProps = {
    onUpdateAnanlyticsData: () => {},
    onUpdateAppSwipe: () => {}
  };

  getInitialPageIndex = (usageAnalyticsModel) => {
    const usageAnalytics = usageAnalyticsModel.getPreviousAggUsageAnalytics();
    const { flashActivity } = this.props;
    if(usageAnalytics.length == 0){
      return 1;
    }
    let index = usageAnalytics.findIndex(n => n === 0);
    if(index === -1){
      index = flashActivity.flashcardPages.findIndex(page => 
        page.pageMetaData.isQuiz() && 
        page.pageMetaData.questionConfig.getIsMandatory() &&
        !page.pageMetaData.questionResponse.isAnswered()
      );
    }
    if(index <= 0){
      return 1;
    }
    const prevPage = flashActivity.flashcardPages[index - 1];
    if (!prevPage) {
      return index + 1;
    }
    const { pageMetaData } = prevPage;
    if (!prevPage || !pageMetaData.isQuiz()) {
      return index + 1;
    }
    const questionResponse = pageMetaData.questionResponse;
    if(!questionResponse || !pageMetaData.questionConfig.getIsMandatory()){
      return index + 1;
    }
    return Math.min(index + (questionResponse.isAnswered() ? 1 : 0 ), flashActivity.flashcardPages.length);
  }

  componentDidMount() {
    const me = this;
    this.updateCurrentUsageAnalytics();
    if (typeof document.hidden !== "undefined") {
      this.setState({
        documentActiveChecker: setInterval(() => {
          if (me.state.isDocumentBeingViewed !== !document.hidden) {
            me.setState({
              isDocumentBeingViewed: !document.hidden
            });
          }
        }, 150)
      });
    }
    document.addEventListener("touchstart", this.onTouchStart);
    document.addEventListener("touchmove", this.onTouchMove);
    document.addEventListener("touchend", this.onTouchEnd);
  }

  componentWillUnmount() {
    clearInterval(this.state.documentActiveChecker);
    document.removeEventListener("touchstart", this.onTouchStart);
    document.removeEventListener("touchmove", this.onTouchMove);
    document.removeEventListener("touchend", this.onTouchEnd);
  }

  onTouchStart = e => {
    this.touchStartPoints = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    }
    this.swipeAllowed = this.canSwipePage();
  }

  onTouchMove = e => {
    this.attemptedSwipe = true;
  };

  onTouchEnd = e => {
    //check if the user can swipe
    const now = new Date().valueOf();
    if (
      !this.swipeAllowed &&
      this.attemptedSwipe &&
      !this.state.dndInProgress &&
      Math.abs(this.touchStartPoints.x - e.changedTouches[0].pageX) > Math.abs(this.touchStartPoints.y - e.changedTouches[0].pageY) &&
      Math.abs(this.touchStartPoints.x - e.changedTouches[0].pageX) > (.15 * document.body.clientWidth)
    ) {
      this.lastAlertTime = now;
      this.props.showToastMessage(
        "This is a mandatory question : Please answer to move forward "
      );
    } else {
    }

    if (
      !this.attemptedSwipe &&
      !["radio", "button", "input", "submit"].includes(e.target.type) &&
      $(e.target).parents(
        ".audio-playback-container, .answer-container:not(.match-options), .explanation-container, .video-activity-element"
      ).length === 0
    ) {
      this.props.onTap();
    }
    this.touchStartPoints = {};
    this.attemptedSwipe = false;
    this.swipeAllowed = true;
    if (this.state.dndInProgress) {
      this.setState({
        dndInProgress: false
      });
    }
  };

  swipeLeft = () => {
    if (this.canSwipePage(LEFT)) {
      this.onPageSlide(this.state.currentPageIndex - 1);
    } else {
      this.props.showToastMessage(
        "This is a mandatory question : Please answer to move forward "
      );
    }
  };

  swipeRight = () => {
    if (this.canSwipePage(RIGHT)) {
      this.onPageSlide(this.state.currentPageIndex + 1);
    } else {
      this.props.showToastMessage(
        "This is a mandatory question : Please answer to move forward "
      );
    }
  };

  render() {
    const { flashActivity } = this.props;
    const { currentPageIndex, isDocumentBeingViewed } = this.state;
    return (
      <div className={`flashcard-page-container`} key="flashcard_container">
        <SwipeableViews
          key="flashcard_swipeable_view"
          enableMouseEvents={true}
          index={currentPageIndex || 0}
          style={{ height: "100%" }}
          slideStyle={{ height: "100%" }}
          disabled={!this.canSwipePage()}
          onChangeIndex={this.onPageSlide.bind(this)}
        >
          {["dummy"]
            .concat(flashActivity.flashcardPages)
            .map(function(page, index) {
              if (page === "dummy") {
                return <div />;
              }
              const containerStyle = {};
              var backgroundDiv = "";
                var pageBackgroundImage = "url('" + page.pageMetaData.getBackgroundUrl() + "')";
                var hasBackgroundImage = page.pageMetaData.getBackgroundUrl() !== '';
              if(flashActivity.getPreviewLayout() === "fixed") {
                  containerStyle.opacity = (page.pageMetaData.getBackgroundOpacity() / 100);
                  containerStyle.background = hasBackgroundImage ? pageBackgroundImage : this.getLinearGradient(flashActivity.getThemeBackgroundColor() || "white");
                  backgroundDiv = <div className={"fixed-background"}
                                       style={containerStyle}></div>
              }
              return (
                <div className={`page-view-ctr ${flashActivity.getPreviewLayout()}`}>
                    {backgroundDiv}
                  <FlashcardPageView
                    key={page.pageId}
                    page={page}
                    isPageActive={
                      currentPageIndex === index && isDocumentBeingViewed
                    }
                    isItemToBeloaded= {(index === currentPageIndex + 1) || (index === currentPageIndex - 1) || (index === currentPageIndex + 2) || (index === currentPageIndex - 2)}
                    themeBackgroundColor={flashActivity.getThemeBackgroundColor()}
                    themeColor={flashActivity.getThemeColor()}
                    previewLayout={flashActivity.getPreviewLayout()}
                    onQuestionSubmit={this.onQuestionSubmit}
                    onDnDStart={this.onDnDStart}
                  />
                </div>
              );
            }, this)
            .concat(this.getScoreCard() || [])
            .concat(<div />)}
        </SwipeableViews>
      </div>
    );
  }

  getScoreCard() {
    const { flashActivity } = this.props;
    if (flashActivity.hasQuiz()) {
      const responses = flashActivity.getAllQuestionResponses();
      const total = responses.length;
      const correctResponses = responses.filter(
        r => r.isAnswered() && r.isCorrect
      );
      const incorrectResponses = responses.filter(
        r => r.isAnswered() && !r.isCorrect
      );
      const sumFn = (prev, curr) => {
        return prev + curr.getScore();
      };
      const correctScore = correctResponses.reduce(sumFn, 0);
      const incorrectScore = incorrectResponses.reduce(sumFn, 0);
      const totalScore = correctScore + incorrectScore;
      const bgColor = flashActivity.getThemeBackgroundColor();
      const color = flashActivity.getThemeColor();
      const hasScore = flashActivity.hasScore();
      return (
        <div
          className={`flashactivity-quiz-scorecard-ctr ${
            hasScore ? "" : "no-score"
          }`}
          style={{ backgroundColor: bgColor }}
        >
          <div className="scorecard-content">
            <label style={{ color: color }}>
              {hasScore ? "You Scored..." : "Your Answers.."}
            </label>
            <span
              className="final-score"
              style={{ backgroundColor: color, color: bgColor }}
            >
              {totalScore}
            </span>
            <div
              className="score-breakup-ctr"
              style={{
                backgroundColor: color,
                color: bgColor,
                borderColor: color
              }}
            >
              <span>
                Correct <br /> Answers
              </span>
              <span>
                {correctResponses.length}/{total}
              </span>
              <span
                className="breakup-score"
                style={{ backgroundColor: bgColor, color: color }}
              >
                {correctScore}
              </span>
              <span>points</span>
            </div>
            <div
              className="score-breakup-ctr"
              style={{
                backgroundColor: bgColor,
                color: color,
                borderColor: color
              }}
            >
              <span>
                Wrong <br /> Answers
              </span>
              <span>
                {incorrectResponses.length}/{total}
              </span>
              <span
                className="breakup-score"
                style={{ backgroundColor: color, color: bgColor }}
              >
                {incorrectScore}
              </span>
              <span>points</span>
            </div>
          </div>
        </div>
      );
    }

    return;
  }

  onQuestionSubmit = (page, userSelection) => {
    const {
      usageAnalyticsModel,
      currentPageIndex,
      usageTimestamp
    } = this.state;
    const isCorrect = page.pageMetaData.isCorrect(userSelection);
    const score = page.pageMetaData.questionConfig.computeScore(userSelection);
    const now = new Date().valueOf();
    if (!page.pageMetaData.questionResponse.isAnswered()) {
      page.pageMetaData.questionResponse.markAsAnswered(
        userSelection,
        isCorrect
      );
    }
    page.pageMetaData.questionResponse.setScore(score);
    //set time spent based on the usage analytics of current page
    page.pageMetaData.questionResponse.setTimeSpent(
      usageAnalyticsModel.getCurrentUsageAnalytics()[currentPageIndex - 1] +
        now -
        usageTimestamp
    );
    //set time spent based on the usage analytics of current page
    page.pageMetaData.questionResponse.setTimeSpent(
      usageAnalyticsModel.getCurrentUsageAnalytics()[currentPageIndex - 1]
    );
    //post message to APP
    this.props.saveQuizData(
      page.pageMetaData.questionId,
      page.pageMetaData.questionResponse
    );

    //force rerender
    this.setState({});
  };

  onPageSlide = index => {
    const newIndex = index;
    const { flashActivity } = this.props;
    const oldIndex = this.state.currentPageIndex;
    let notifyAppToSwipe = false;
    let swipeDirection = "";
    this.updateCurrentUsageAnalytics();
    if (index === 0) {
      index = oldIndex;
      notifyAppToSwipe = true;
      swipeDirection = "start";
    }
    if (
      index >
      flashActivity.flashcardPages.length + (flashActivity.hasQuiz() ? 1 : 0)
    ) {
      index = oldIndex;
      notifyAppToSwipe = true;
      swipeDirection = "end";
    }
    this.setState(
      {
        currentPageIndex: newIndex
      },
      () => {
        this.updateCurrentUsageAnalytics();
        let me = this;
        if(notifyAppToSwipe){
          setTimeout(() => {
            me.setState({
              currentPageIndex: index
            });
          }, 600);
        }
      }
    );
    if (notifyAppToSwipe) {
      this.props.onUpdateAppSwipe(swipeDirection);
      //TODO: NOTIFY disprz app to swipe back for forward
    }
  };

  canSwipePage(swipeDirection) {
    const { flashActivity } = this.props;
    const { currentPageIndex } = this.state;
    const page = flashActivity.flashcardPages[currentPageIndex - 1];
    if (!page) {
      return true;
    }
    const { pageMetaData } = page;
    if (!page || !pageMetaData.isQuiz()) {
      return true;
    }
    const questionResponse = pageMetaData.questionResponse;
    if (!questionResponse || !pageMetaData.questionConfig.getIsMandatory()) {
      return true;
    }
    if (swipeDirection === LEFT && !pageMetaData.questionConfig.isTimed()) {
      return true;
    }
    return questionResponse.isAnswered();
  }

  onDnDStart = () => {
    this.setState({
      dndInProgress: true
    });
  };

  getLinearGradient = color => {
      //check if color is rgb or hex format
      if (color.match("#[0-9A-Fa-f]{6}") !== null) {
          color = this.getRGBFromHex(color);
      }
      const regExp = /\(([^)]+)\)/;
      const matches = regExp.exec(color);
      if (!matches) {
          return color;
      }
      const rgbValues = matches[1];
      return `linear-gradient(to bottom, rgb(${rgbValues}), rgba(${rgbValues}, .8))`;
  };

  getRGBFromHex = hex => {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
          ? `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
              result[3],
              16
          )})`
          : null;
  };


    updateCurrentUsageAnalytics() {
    const {
      usageAnalyticsModel,
      currentPageIndex,
      usageTimestamp
    } = this.state;
    const { flashActivity } = this.props;
    const now = new Date().valueOf();
    if (
      currentPageIndex <= flashActivity.flashcardPages.length &&
      currentPageIndex !== 0
    ) {
      usageAnalyticsModel.updateCurrentUsageAnalytics(
        currentPageIndex,
        now - usageTimestamp
      );
    }
    this.setState(
      {
        usageAnalyticsModel: usageAnalyticsModel,
        usageTimestamp: now
      },
      () => {
        const isComplete =
          flashActivity.isComplete ||
          (usageAnalyticsModel.isUsageComplete() &&
            flashActivity.isAllQuestionsAnswered(true));
        this.props.onUpdateAnanlyticsData({
          dataToPost: {
            metaData: usageAnalyticsModel.getCurrentUsageAnalytics(),
            markComplete: isComplete
          },
          currentPageIndex: this.state.currentPageIndex - 1,
          currentProgress: this.getProgress()
        });
      }
    );
  }

  getProgress() {
    //get visited and unanswered count
    const { flashActivity } = this.props;
    const { usageAnalyticsModel } = this.state;
    const aggregatedPreviousUsageAnalytics = usageAnalyticsModel.getPreviousAggUsageAnalytics();
    const currentUsageAnalytics = usageAnalyticsModel.getCurrentUsageAnalytics();
    let unansweredCount = 0;
    currentUsageAnalytics.forEach((val, i) => {
      const timeSpent = val + (aggregatedPreviousUsageAnalytics[i] || 0);
      const page = flashActivity.flashcardPages[i];
      if (timeSpent > 0 && page && page.isUnanswered(true)) {
        unansweredCount++;
      }
    });
    const unansweredPercentage =
      (100 * unansweredCount) / flashActivity.flashcardPages.length;
    const currentProgress = usageAnalyticsModel.getUsageCompletionPercentage(
      true
    );
    return Math.max(currentProgress - unansweredPercentage, 0).toFixed();
  }

  getAnalyticsData() {
    const { usageAnalyticsModel } = this.state;
    const { flashActivity } = this.props;
    return {
      dataToPost: {
        metaData: usageAnalyticsModel.getCurrentUsageAnalytics(),
        markComplete:
          flashActivity.isComplete ||
          (usageAnalyticsModel.isUsageComplete() &&
            flashActivity.isAllQuestionsAnswered(true))
      },
      currentPageIndex: this.state.currentPageIndex - 1,
      currentProgress: this.getProgress()
    };
  }
}

export default FlashcardView;
